(() => {
  'use strict';

  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const revealAll = () => {
    for (const el of document.querySelectorAll('[data-wim-reveal], [data-wim-reveal-item]')) {
      el.style.opacity = '';
      el.style.transform = '';
      el.classList.add('wim-in');
    }
  };

  // Fallback sin GSAP: IntersectionObserver + clase .wim-in (transición CSS).
  const initIO = () => {
    if (!('IntersectionObserver' in window)) { revealAll(); return; }
    const io = new IntersectionObserver((entries) => {
      for (const e of entries) {
        if (e.isIntersecting) { e.target.classList.add('wim-in'); io.unobserve(e.target); }
      }
    }, { rootMargin: '0px 0px -10% 0px' });

    for (const el of document.querySelectorAll('[data-wim-reveal]')) {
      if (el.hasAttribute('data-wim-reveal-stagger')) {
        for (const it of el.querySelectorAll('[data-wim-reveal-item]')) io.observe(it);
      } else {
        io.observe(el);
      }
    }
  };

  const initGSAP = () => {
    const { gsap } = window;
    const ST = window.ScrollTrigger;
    gsap.registerPlugin(ST);

    for (const el of gsap.utils.toArray('[data-wim-reveal]')) {
      if (el.hasAttribute('data-wim-reveal-stagger')) {
        const items = el.querySelectorAll('[data-wim-reveal-item]');
        gsap.to(items, {
          opacity: 1, y: 0, x: 0, scale: 1, duration: 0.6, stagger: 0.1, ease: 'power2.out',
          scrollTrigger: { trigger: el, start: 'top 85%', once: true },
        });
      } else {
        gsap.to(el, {
          opacity: 1, y: 0, x: 0, scale: 1, duration: 0.6, ease: 'power2.out',
          scrollTrigger: { trigger: el, start: 'top 85%', once: true },
        });
      }
    }

    // Parallax suave (solo transform, scrubbed). Evitar en LCP/hero text.
    for (const el of gsap.utils.toArray('[data-wim-parallax]')) {
      const amt = Number.parseFloat(el.getAttribute('data-wim-parallax')) || 0.15;
      gsap.to(el, {
        yPercent: amt * 100, ease: 'none',
        scrollTrigger: { trigger: el, start: 'top bottom', end: 'bottom top', scrub: true },
      });
    }
  };

  const start = () => {
    if (reduce) { revealAll(); return; }
    if (window.gsap && window.ScrollTrigger) {
      try { initGSAP(); } catch (e) { console.warn('[wim-reveal] gsap failed, revealing', e); revealAll(); }
    } else {
      initIO();
    }
  };

  if (document.readyState !== 'loading') start();
  else document.addEventListener('DOMContentLoaded', start);

  // Seguridad: si GSAP no cargó (bloqueado) y nada se reveló, mostrar todo.
  setTimeout(() => {
    if (!reduce && !window.gsap && !document.querySelector('.wim-in')) revealAll();
  }, 3000);
})();
